const placeholder = document.querySelector('#reviews-placeholder');
const loadBtn = document.querySelector('#loadComments');
const commentForm = document.querySelector('#commentform');
let page = 2; // Should start at 2, first batch (or page) of comments will be loaded through php

export const ajaxReviews = (() => {
    // check if the elements exists
    if (placeholder !== null && loadBtn !== null) {
        // Load first batch on pageload
        // getReviews();

        // Load the rest on click
        loadBtn.addEventListener('click', (e) => {
            // Prevent page from reloading
            e.preventDefault();

            // Call function
            getReviews();
        });
    }
})();

/**
 * Function to get reviews or comments
 */
function getReviews() {
    // Disable button
    loadBtn.classList.add('disabled');
    // Add spinner
    const spinner = document.createElement('div');
    spinner.innerHTML = `<div role="status" class="spinner-border spinner-border-sm text-primary"><span class="visually-hidden">Reviews aan het zoeken...</span></div>`;
    loadBtn.append(spinner);

    let reviewsOrComments;

    if (loveli_reviews_ajax.post_type == 'product') {
        reviewsOrComments = 'reviews';
    } else {
        reviewsOrComments = 'reacties';
    }

    const paramsObject = {
        action: 'loveli_load_comments',
        postid: loveli_reviews_ajax.post_id,
        post_type: loveli_reviews_ajax.post_type,
        page: page,
    };

    const paramsUrl = new URLSearchParams(paramsObject).toString();

    // Make the ajax call
    fetch(`${loveli_reviews_ajax.ajax_url}?${paramsUrl}`, {
        method: 'GET',
    })
        .then((response) => response.text()) // We're getting HTML, so we need the text() method
        .then((data) => {
            // Add check
            spinner.innerHTML = '<i class="fa-solid fa-check pop-lg"></i>';
            // Early return if there's no data to be shown
            if (data === '') {
                return (loadBtn.innerHTML = `Alle ${reviewsOrComments} zijn geladen`);
            }

            // Wait for the checkmark animation to end before adding the content
            loadBtn.addEventListener(
                'animationend',
                () => {
                    placeholder.innerHTML += data;
                    spinner.remove();
                    loadBtn.classList.remove('disabled');
                },
                { once: true }
            );

            // Preset the next page
            page++;
        })
        .catch((err) => {
            console.log(err);
            placeholder.innerHTML = `Oeps! Er is iets misgegaan bij het laden van de ${reviewsOrComments}. Wil je ons even een berichtje sturen via <a href="mailto:linda@loveli.care">linda@loveli.care</a>? Dan gaan we het oplossen!`;
            spinner.remove();
        });
}
